var _path, _path2, _path3, _mask, _path4, _path5, _mask2, _path6, _path7, _mask3, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 21,
    viewBox: "0 0 55 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7131 0.891785L36.5214 0.901785C36.2169 0.935021 35.9272 1.04717 35.6824 1.22655C35.4376 1.40592 35.2468 1.64594 35.1298 1.92157C35.0128 2.1972 34.9739 2.49835 35.0172 2.79359C35.0605 3.08884 35.1844 3.36736 35.3759 3.60012L41.3702 10.8918L35.3776 18.1835C35.1761 18.4285 35.0497 18.724 35.0131 19.0359C34.9765 19.3477 35.0311 19.6633 35.1706 19.9463C35.3102 20.2293 35.529 20.4682 35.8019 20.6355C36.0748 20.8027 36.3906 20.8916 36.7131 20.8918H41.2789C41.5354 20.8916 38.7886 20.8354 39.0197 20.7272C39.2509 20.619 39.4541 20.4617 39.6144 20.2668L46.4631 11.9335C46.7062 11.6378 46.8387 11.2705 46.8387 10.8918C46.8387 10.5131 46.7062 10.1457 46.4631 9.85012L39.6144 1.51678C39.4541 1.32189 39.2509 1.16454 39.0197 1.05636C38.7886 0.948185 41.5354 0.891941 41.2789 0.891785H36.7131Z",
    fill: "#EE1313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7131 0.891785L44.5214 0.901785C44.2169 0.935021 43.9272 1.04717 43.6824 1.22655C43.4376 1.40592 43.2468 1.64594 43.1298 1.92157C43.0128 2.1972 42.9739 2.49835 43.0172 2.79359C43.0605 3.08884 43.1844 3.36736 43.3759 3.60012L49.3702 10.8918L43.3776 18.1835C43.1761 18.4285 43.0497 18.724 43.0131 19.0359C42.9765 19.3477 43.0311 19.6633 43.1706 19.9463C43.3102 20.2293 43.529 20.4682 43.8019 20.6355C44.0748 20.8027 44.3906 20.8916 44.7131 20.8918H49.2789C49.5354 20.8916 46.7886 20.8354 47.0197 20.7272C47.2509 20.619 47.4541 20.4617 47.6144 20.2668L54.4631 11.9335C54.7062 11.6378 54.8387 11.2705 54.8387 10.8918C54.8387 10.5131 54.7062 10.1457 54.4631 9.85012L47.6144 1.51678C47.4541 1.32189 47.2509 1.16454 47.0197 1.05636C46.7886 0.948185 49.5354 0.891941 49.2789 0.891785H44.7131Z",
    fill: "#A80505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7131 0.891785L13.5214 0.901785C13.2169 0.935021 12.9272 1.04717 12.6824 1.22655C12.4376 1.40592 12.2468 1.64594 12.1298 1.92157C12.0128 2.1972 11.9739 2.49835 12.0172 2.79359C12.0605 3.08884 12.1844 3.36736 12.3759 3.60012L18.3702 10.8918L12.3776 18.1835C12.1761 18.4285 12.0497 18.724 12.0131 19.0359C11.9765 19.3477 12.0311 19.6633 12.1706 19.9463C12.3102 20.2293 12.529 20.4682 12.8019 20.6355C13.0748 20.8027 13.3906 20.8916 13.7131 20.8918H30.2789C30.5354 20.8916 30.7886 20.8354 31.0197 20.7272C31.2509 20.619 31.4541 20.4617 31.6144 20.2668L38.4631 11.9335C38.7062 11.6378 38.8387 11.2705 38.8387 10.8918C38.8387 10.5131 38.7062 10.1457 38.4631 9.85012L31.6144 1.51678C31.4541 1.32189 31.2509 1.16454 31.0197 1.05636C30.7886 0.948185 30.5354 0.891941 30.2789 0.891785H13.7131Z",
    fill: "#FCB036"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_433_214",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4.89178,
    width: 21,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 4.89178,
    width: 21,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.89178H25V7.89178H4V5.89178Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.89178H25V7.89178H4V5.89178Z",
    fill: "#FCB036"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.89178H25V4.89178H4V6.89178Z",
    fill: "white",
    mask: "url(#path-4-outside-1_433_214)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_433_214",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8.89178,
    width: 15,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 8.89178,
    width: 15,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.89178H24V11.8918H9V9.89178Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.89178H24V11.8918H9V9.89178Z",
    fill: "#FCB036"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.8918H24V8.89178H9V10.8918Z",
    fill: "white",
    mask: "url(#path-6-outside-2_433_214)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-3_433_214",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12.8918,
    width: 21,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 12.8918,
    width: 21,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.8918H21V15.8918H0V13.8918Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.8918H21V15.8918H0V13.8918Z",
    fill: "#FCB036"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.8918H21V12.8918H0V14.8918Z",
    fill: "white",
    mask: "url(#path-8-outside-3_433_214)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedArrows);
export default __webpack_public_path__ + "static/media/speed-arrows.e4365245d1387fca68a3060d51388b18.svg";
export { ForwardRef as ReactComponent };